import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import '../stylesheets/km-date-picker.sass'

export default class KmDatePicker extends Component {

  render() {
    return(
      <div className={this.props.wrapperClass} style={{ ...this.props.wrapperStyle }} >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            maxWidth: 315
          }}>
          { this.props.label &&
            <label>
              { this.props.label }
            </label>
          }
          { this.props.questionMark &&
            <div
              data-tip={ this.props.dataTip }
              style={{
                padding: 5,
                borderRadius: '50%',
                backgroundColor: '#B4B4B4',
                color: 'white',
                width: 20,
                height: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <div style={{ color: 'white'}}>
                ?
              </div>
            </div>
            }
        </div>
        <DatePicker
          selected={ this.props.date }
          onChange={ this.props.change }
          className={ `${this.props.extraClass} date-picker` }
          { ...this.props }
        />
      </div>
     )
   }
 }



// WEBPACK FOOTER //
// ./src/shared/KmDatePicker.jsx